import React from "react";

// Custom tooltip component
const WarTooltip = ({ war, position }) => {
  let warResultClasses = ["warheaderlost", "warheadertie", "warheaderwon"];

  return (
    <div
      className="wartooltip"
      style={{ top: position.top, left: position.left }}
    >
      <div className={"warColumn " + warResultClasses[war.result + 1]}>
        <div>{war.clanId.name}</div>
        <div>{war.stars}</div>
        <div>{war.attacks}</div>
        <div>{(Math.round(war.perc * 100) / 100).toFixed(2)}</div>
      </div>
      <div className="warColumn">
        <div>{war.warType.toUpperCase()}</div>
        <div>stars</div>
        <div>attacks</div>
        <div>%</div>
      </div>
      <div className={"warColumn " + warResultClasses[1 - war.result]}>
        <div>{war.opponentId.name}</div>
        <div>{war.ostars}</div>
        <div>{war.oattacks}</div>
        <div>{(Math.round(war.operc * 100) / 100).toFixed(2)}</div>
      </div>
    </div>
  );
};

export default WarTooltip;
